export default {
    "just_now": "Just now",
    "minutes_ago": "{0} minutes ago",
    "hours_ago": "{0} hours ago",
    "days_ago": "{0} days ago",
    "months_ago": "{0} months ago",
    "years_ago": "{0} years ago",
    "less_than_minute": "Less than minute",
    "minutes_duration": "{0} minutes",
    "hours_duration": "{0} hours",
    "throw_days": "Throw days",
    "all": "All",
    "buyer": "Buyer",
    "seller": "Seller",
    "general-tips": "General Tips",
    "search": "Search",
    "message-text": "Message Text...",
    "response_estimated": "Typically replies in {0}",
    "response_time": "Regular response time",
    "block_user": "Block User",
    "confirmation_question-blocked": "Are you sure, You want to block this user ?",
    "confirmation_question-delete-chat": "Are you sure, You want to delete chat ?",
    "yes": "Yes",
    "no": "No",
    "delete-room": "Delete Chat",
    "download": "download",
    "no_chats_messages": "No chat messages",
    "internet_not_connected_title": "Device not connected",
    "internet_not_connected_description": "Make sure your device has an active Internet connection.",
    "not_connected_offline": "You're offline",
    "not_connected_check": "Check your connection or retry again",
    "try_again": "Try again",
    "typing": "typing...",
    "ADD_VIN_NUMBER": "Add VIN Number",
    "ASK_FOR_PRICE": "Add the price",
    "ASK_FOR_DROP_PRICE": "Drop the price",
    "ASK_FOR_IMAGE": "Add images",
    "ASK_FOR_MAP": "Add the map",
    "APPLY_TO_JOB": "Check CV",
    "ASK_FOR_PRICE_S2B_BUYER": "Check Price",
    "ASK_FOR_DROP_PRICE_S2B": "Check Price",
    "ASK_FOR_VIN_S2B": "Check the VIN",
    "ASK_FOR_LOCATION_S2B": "Check the map",
    "ASK_FOR_IMAGE_S2B": "Check the images",
    'ASK_FOR_VIDEO_S2B': "Check the video",
    'ASK_FOR_VIDEO': "Add a video"
};
